import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=991e7246&scoped=true&"
import script from "./Templates.vue?vue&type=script&lang=ts&"
export * from "./Templates.vue?vue&type=script&lang=ts&"
import style0 from "./Templates.vue?vue&type=style&index=0&id=991e7246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991e7246",
  null
  
)

export default component.exports